import { AppRouteProps } from "@harea/component";
import React from "react";

const AvanceListContainer = React.lazy(() => import("./container/AvanceListContainer"));

export const AvanceListRoutes = [
    {
        path: "avance",
        element: <AvanceListContainer />,
        title: "BSMRH.Avance.Title",
    },
] as Array<AppRouteProps>;
